export type ExportTableViewParams = {
  fileName: string
  headers: { key: string; title: string; unit?: string | null }[]
  rows: Record<string, string | number | null>[]
}

export type CSVCell = string | number | null

export type CSVColumn = { title: string; unit?: string | null }

function quoteCSVCell(value: CSVCell | undefined): string {
  if (value === null || value === undefined || value === "") {
    return '"-"'
  }

  return `"${String(value).replace(/"/g, '""')}"`
}

/**
 * \ub80c\ub354\ub41c \ud45c(\uceec\ub7fc + \ud589\ub82c)\ub97c CSV \ubb38\uc790\uc5f4\ub85c \ub9cc\ub4e0\ub2e4 \u2014 \ub9ac\ud3ec\ud2b8/\uc77c\uad04 CSV \uacf5\ud1b5 \ub2e8\uc77c \ud3ec\ub9f7.
 * \ud5e4\ub354\ub294 \ub2e8\uc704 \ud45c\uae30\ub97c \ubd99\uc774\uace0, \ubaa8\ub4e0 \uc140\uc740 RFC 4180 \ub530\uc634\ud45c \uc774\uc2a4\ucf00\uc774\ud504(\ube48\uac12\uc740 "-")\ud55c\ub2e4.
 */
export function buildCSVString(columns: CSVColumn[], rows: CSVCell[][]): string {
  const headerRow = columns
    .map((col) => (col.unit ? `"${col.title} (${col.unit})"` : `"${col.title}"`))
    .join(",")
  const dataRows = rows.map((row) => columns.map((_, i) => quoteCSVCell(row[i])).join(","))

  return [headerRow, ...dataRows].join("\n")
}

export function triggerBlobDownload(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = fileName
  a.click()
  URL.revokeObjectURL(url)
}

export function exportTableFromView({ fileName, headers, rows }: ExportTableViewParams) {
  const csvContent = buildCSVString(
    headers.map((header) => ({ title: header.title, unit: header.unit })),
    rows.map((row) => headers.map((header) => row[header.key])),
  )

  const blob = new Blob(["\ufeff"].concat(csvContent), { type: "text/csv" })
  triggerBlobDownload(blob, fileName.endsWith(".csv") ? fileName : `${fileName}.csv`)
}
